import { useMyUnresolvedCount } from '@incidents/entities/incident';
import { Badge } from '@/shared/ui';

// Numeric badge over the header incidents trigger. Subscribes to
// incidents.myUnresolvedCount; updates without polling whenever an incident
// mutation invalidates the query. Renders nothing when the count is 0.
export const IncidentCountBadge = () => {
  const { data } = useMyUnresolvedCount();
  if (!data || data === 0) return null;
  return <Badge variant="error">{data}</Badge>;
};
